import * as React from "react";

import UploadFileIcon from "@mui/icons-material/UploadFile";

import "containers/Tiptap/components/tiptap-node/image-upload-node/image-upload-node.scss";
import { ImageUploadPreviewProps } from "./types";
import {
  FileContainerUploading,
  Wrapper,
  FileIconContainer,
  FileName,
  ProgressText,
  ProgressBar,
  ProgressBarFill,
} from "../attachment-node/styles";
import { Box } from "@mui/material";

const ImageUploadPreview: React.FC<ImageUploadPreviewProps> = ({ file, progress, status }) => (
  <FileContainerUploading key={`${file.name}-${file.lastModified}-${file.size}`}>
    <Wrapper style={{ flex: 1 }}>
      <FileIconContainer>
        <UploadFileIcon sx={{ color: "#757575" }} />
      </FileIconContainer>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <FileName>{file.name}</FileName>
          {status === "uploading" && <ProgressText>{progress}%</ProgressText>}
        </Box>
        {status === "uploading" && (
          <ProgressBar>
            <ProgressBarFill $progress={progress} />
          </ProgressBar>
        )}
      </Box>
    </Wrapper>
  </FileContainerUploading>
);

export default ImageUploadPreview;
